// extracted by mini-css-extract-plugin
export default {"reg_form":"update_reg_form__jB2R-","reg_form_div":"update_reg_form_div__danLS","errorMessage":"update_errorMessage__+giXR","successMessage":"update_successMessage__LnGMj"};